export default "__VITE_ASSET__Dp5fwSF2__"